import React from 'react';
import ReactPlayer from 'react-player';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import { PropTypes } from 'prop-types';
import IconContainer from '../IconContainer';
import * as youtubeStyles from '../../../styles/widgets/youtube.module.scss';

const Youtube = ({
  playingVideoIndex,
  setPlayingVideoIndex,
  index,
  youtubeVideos,
  indexYoutubeVideo,
  column,
  row,
}) => {
  if (youtubeVideos?.length === 0)
    return ;
  const video = youtubeVideos[indexYoutubeVideo];
  const [playing, setPlaying] = React.useState(false);
  const handlePlay = () => {
    setPlaying(true);
  };

  const [iconColor, setIconColor] = React.useState('RED');
  const [hoverColor, setHoverColor] = React.useState('WHITE');

  const {t} = useTranslation();


  const ref = React.useRef(null);
  const changeIconColor = (color, hoverColor) => {
    setIconColor(color);
    setHoverColor(hoverColor);
  };

  const [imageUrl, setImageUrl] = React.useState(null);

  React.useEffect(()=>{
    setPlaying(playingVideoIndex===index);
    const highUrl = video?.thumbnails?.[4];
    if(highUrl){
      if (
        (ref.current.clientWidth * highUrl.height) / highUrl.width <
          ref.current.clientHeight
      ) {
        setImageUrl(video?.thumbnails?.[3].url);
      } else {
        setImageUrl(highUrl?.url);
      }
    }

  }, [playingVideoIndex, video?.id, video?.thumbnails, index]);

  return (
    <div
      className={youtubeStyles.bloc}
      onMouseEnter={() => changeIconColor('WHITE', 'RED')}
      onMouseLeave={() => changeIconColor('RED', 'WHITE')}
      ref={ref}
      role={'presentation'}
    >
      {video && (
        <div className={youtubeStyles.wrapper}>
          {playing ? (
            <>
              <div
                style={{
                  paddingBottom: `calc((100% / ${column}) * (${row}))`,
                  gridArea: '1 / 1 / -1 / -1'
                }}
              />
              <ReactPlayer
                controls
                height="100%"
                loop={false}
                muted={false}
                onEnded={() => setPlaying(false)}
                playing
                url={`https://youtube.com/embed/${video?.id}`}
                width="100%"
              />
            </>
          ) : (
            <>
              <div
                className={`${youtubeStyles.overlay} ${youtubeStyles.writing}`}
              >
                <span
                  className={clsx(youtubeStyles.textWithBackground, youtubeStyles.title)}
                >
                  {video?.title}
                </span>
              </div>
              <div
                style={{
                  paddingBottom: `calc((100% / ${column}) * (${row}))`,
                  gridArea: '1 / 1 / -1 / -1'
                }}
              />
              <ReactPlayer
                className={youtubeStyles.youtubePlayer}
                height="100%"
                light={imageUrl ? imageUrl : true}
                loop={false}
                muted
                onClick={() => {
                  setPlayingVideoIndex(index);
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    setPlayingVideoIndex(index);
                  }
                }}
                playIcon={
                  <div
                    aria-label={t(`search.${'embedded.button.play'}`)}
                    className={youtubeStyles.youtube}
                    onClick={handlePlay}
                    onKeyPress={handlePlay}
                    role="button"
                    tabIndex="0"
                    title={video?.title}
                  >
                    <IconContainer
                      color={iconColor}
                      hoverColor={hoverColor}
                      icon="YOUTUBE"
                      size={40}
                    />
                  </div>
                }
                playing={false}
                url={`https://youtube.com/embed/${video?.id}`}
                width="100%"
              />
            </>
          )}
        </div>
      )}
    </div>
  );
};

Youtube.propTypes = {
  column: PropTypes.number,
  index: PropTypes.number,
  indexYoutubeVideo: PropTypes.number,
  playingVideoIndex: PropTypes.number,
  row: PropTypes.number,
  setPlayingVideoIndex: PropTypes.func,
  youtubeVideos: PropTypes.array,
};

export default Youtube;
